import { render, staticRenderFns } from "./PayCard.vue?vue&type=template&id=ec7c46d6&scoped=true"
import script from "./PayCard.vue?vue&type=script&lang=js"
export * from "./PayCard.vue?vue&type=script&lang=js"
import style0 from "./PayCard.vue?vue&type=style&index=0&id=ec7c46d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7c46d6",
  null
  
)

export default component.exports